import React from 'react';
import { useAdmin } from '../context/AdminContext';
import { LogIn, LogOut, Edit3, Eye, Settings, Save } from 'lucide-react';

const AdminToolbar = () => {
  const { 
    isAdmin, 
    isEditMode, 
    toggleEditMode, 
    logout, 
    setShowLoginModal,
    setShowContentPanel,
    hasUnsavedChanges,
    saveAllChanges
  } = useAdmin();

  // Hidden trigger: Ctrl+Shift+A opens login modal
  React.useEffect(() => {
    if (isAdmin) return;
    const handler = (e) => {
      if (e.ctrlKey && e.shiftKey && (e.key === 'A' || e.key === 'a' || e.key === 'Ф' || e.key === 'ф')) {
        e.preventDefault();
        setShowLoginModal(true);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [isAdmin, setShowLoginModal]);

  if (!isAdmin) {
    return null;
  }

  // Admin toolbar - top left when logged in
  return (
    <>
      {/* Edit mode indicator overlay */}
      {isEditMode && (
        <div className="fixed top-16 left-1/2 -translate-x-1/2 z-[60] bg-blue-500 text-white px-6 py-3 rounded-b-xl shadow-lg">
          <span className="font-medium">Режим редактирования активен</span>
          <span className="ml-2 text-blue-200">• Кликните на элемент для редактирования</span>
        </div>
      )}
      
      <div className="fixed top-4 left-4 z-50 flex items-center gap-2">
        {/* Edit Mode Toggle */}
        <button
          onClick={toggleEditMode}
          data-testid="edit-mode-toggle"
          className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold shadow-lg transition-all ${
            isEditMode 
              ? 'bg-green-500 hover:bg-green-600 text-white ring-2 ring-green-300 ring-offset-2' 
              : 'bg-[#061d36] hover:bg-[#0d2a47] text-white'
          }`}
        >
          {isEditMode ? (
            <>
              <Eye className="w-5 h-5" />
              <span>Завершить</span>
            </>
          ) : (
            <>
              <Edit3 className="w-5 h-5" />
              <span>Редактировать</span>
            </>
          )}
        </button>

        {/* Content Panel Button */}
        <button
          onClick={() => setShowContentPanel(true)}
          data-testid="content-panel-btn"
          className="flex items-center gap-2 px-4 py-2.5 bg-white hover:bg-gray-100 text-[#061d36] rounded-lg text-sm font-semibold shadow-lg transition-all border border-gray-200"
        >
          <Settings className="w-5 h-5" />
          <span>Контент</span>
        </button>

        {/* Save All Button (if there are unsaved changes) */}
        {hasUnsavedChanges && (
          <button
            onClick={saveAllChanges}
            className="flex items-center gap-2 px-4 py-2.5 bg-yellow-500 hover:bg-yellow-600 text-white rounded-lg text-sm font-semibold shadow-lg transition-all animate-pulse"
          >
            <Save className="w-5 h-5" />
            <span>Сохранить</span>
          </button>
        )}

        {/* Logout */}
        <button
          onClick={logout}
          data-testid="admin-logout-btn"
          className="p-2.5 bg-gray-800/70 hover:bg-[#7a3b3b] text-white rounded-lg shadow-lg transition-all"
          title="Выйти"
        >
          <LogOut className="w-5 h-5" />
        </button>
      </div>
    </>
  );
};

export default AdminToolbar;
